/**
 * Modal component type definitions
 */

export enum ModalSize {
  Small = 'sm',
  Default = 'default',
  Medium = 'md',
  Large = 'lg',
  ExtraLarge = 'xl',
  Full = 'full',
}
